export default __webpack_public_path__ + "static/banner-travel-cost-effective-49107887d4d29bc7a7d7105b1dca28f4.jpg";